module.exports = __webpack_public_path__ + "img/hero-mes.f68de5bd.jpg";